import summaryReportIcon from '@/assets/svg/icons8-block/icons8-estimates 1.svg';
import testReportIcon from '@/assets/svg/icons8-block/icons8-survey 4.svg';
import generalReportIcon from '@/assets/svg/icons8-block/icons8-user-menu-male 1.svg';
import filesReportIcon from '@/assets/svg/icons8-attach.svg';
import essayReportIcon from '@/assets/svg/icons8-block/icons8-edit-filled-text.svg';
import versionExportReportIcon from '@/assets/svg/icon-file.svg';
import scoreReportIcon from '@/assets/svg/ic_points.svg';
import archiveIcon from '@/assets/svg/ic_doc_archive.svg';
import p2pReportIcon from '@/assets/svg/ic_people_grade.svg';

export const ReportTypes = {
    HOMEWORK_FILES: 'files_homework_users',
    HOMEWORK_FILES_ARCHIVE: 'files_homework_answers_files',
    HOMEWORK_ESSAY: 'essay_homework_users',
    HOMEWORK_ESSAY_ARCHIVE: 'essay_homework_answers_files',
    TEST_OR_QUIZ: 'students_answers',
    HOMEWORK_P2P: 'p2p_homework_users',
    HOMEWORK_P2P_ARCHIVE: 'p2p_homework_answers_files',
    EVENT_PARTICIPATION: 'external_homework_users',
    EVENT_PARTICIPATION_ARCHIVE: 'external_homework_answers_files',
    SUMMARY: 'summary',
    STUDENT: 'student',
    STUDENTS_STUDY_PROGRESS: 'students_study_progress',
    COURSE_STUDENT_STATUS: 'course_students_status',
    COURSE_EXPORT: 'course_export',
    STUDENTS_SCORE: 'score',
};

export const ReportQueryType = {
    SUMMARY: ReportTypes.SUMMARY,
    STUDENT: ReportTypes.STUDENT,
    STUDY_PROGRESS: ReportTypes.STUDENTS_STUDY_PROGRESS,
    TEST_OR_QUIZ: ReportTypes.TEST_OR_QUIZ,
    HOMEWORK: 'homework_users',
    EVENT_PARTICIPATION: 'event_participation',
    COURSE_EXPORT: ReportTypes.COURSE_EXPORT,
    STUDENTS_SCORE: ReportTypes.STUDENTS_SCORE,
};

export const ReportCategories = {
    REPORT: 'report',
    ARCHIVE: 'archive',
};

// eslint-disable-next-line max-lines-per-function
export const reportDataMap = {
    [ReportTypes.HOMEWORK_FILES]:
        {
            name: 'Отчет по практике: файл',
            icon: filesReportIcon,
        },
    [ReportTypes.HOMEWORK_FILES_ARCHIVE]:
        {
            name: 'Архив по практике: файл',
            icon: archiveIcon,
        },
    [ReportTypes.HOMEWORK_ESSAY]:
        {
            name: 'Отчет по практике: эссе',
            icon: essayReportIcon,
        },
    [ReportTypes.HOMEWORK_ESSAY_ARCHIVE]:
        {
            name: 'Архив по практике: эссе',
            icon: archiveIcon,
        },
    [ReportTypes.TEST_OR_QUIZ]:
        {
            name: 'Отчет по тестам и опросам',
            icon: testReportIcon,
        },
    [ReportTypes.HOMEWORK_P2P]:
        {
            name: 'Отчет по Peer-to-peer',
            icon: p2pReportIcon,
        },
    [ReportTypes.HOMEWORK_P2P_ARCHIVE]:
        {
            name: 'Архив по Peer-to-peer',
            icon: archiveIcon,
        },
    [ReportTypes.EVENT_PARTICIPATION]:
        {
            name: 'Отчет по мероприятиям',
            icon: summaryReportIcon,
        },
    [ReportTypes.EVENT_PARTICIPATION_ARCHIVE]:
        {
            name: 'Архив по мероприятиям',
            icon: summaryReportIcon,
        },
    [ReportTypes.SUMMARY]:
        {
            name: 'Сводный отчет',
            icon: summaryReportIcon,
        },
    [ReportTypes.STUDENT]:
        {
            name: 'Отчет по ученикам',
            icon: generalReportIcon,
        },
    [ReportTypes.STUDENTS_STUDY_PROGRESS]:
        {
            name: 'Отчет об успеваемости',
            icon: summaryReportIcon,
        },
    [ReportTypes.COURSE_STUDENT_STATUS]:
        {
            name: 'Отчет списка учащихся',
            icon: summaryReportIcon,
        },
    [ReportTypes.COURSE_EXPORT]:
        {
            name: 'Экспорт версии',
            icon: versionExportReportIcon,
        },
    [ReportTypes.STUDENTS_SCORE]:
        {
            name: 'Отчет по баллам',
            icon: scoreReportIcon,
        },
};
